import React, { useEffect, useState } from 'react'
import { PiCourtBasketball } from "react-icons/pi";
import '../Dashboard/Dashboard.scss'
import { GoDotFill } from "react-icons/go";
import { GoArrowUpRight } from "react-icons/go";
import { IoSparklesOutline } from "react-icons/io5";
import { BsBoxSeam } from "react-icons/bs";
import { GoStar } from "react-icons/go";
import axios from 'axios';
import { dashboardapi, getSpecificourt } from '../../Services/BackendUrl';
import { encryptedAuth } from '../../Services/EncryptData';


const Dashboard = ({ setDashActivePage, setIsExporting }) => {
  const [membershipCount, setMembershipCount] = useState(0)
  const [contactCount, setContactCount] = useState(0)
  const [feedbackCount, setFeedbackcount] = useState(0);
  const [courtId, setCourtid] = useState([]);
  const [times, setTimes] = useState([]);       // holds time labels from backend
  const [slotData, setSlotData] = useState([]); // holds slot statuses

  const currentdate = new Date().toISOString().split('T')[0];


  const courtNumber = (courtId[0]?.courts || []).slice(0, 7)
    .map(court => parseInt(court.courtId)).sort((a, b) => a - b);

  useEffect(() => {
    try {
      axios.get(dashboardapi, {
        headers: {
          Authorization : `Encrypted ${encryptedAuth}`
        }
      })
        .then((response) => {
          const feedbackcount = response.data.Feedback;
          setFeedbackcount(feedbackcount)
          const contactcount = response.data.ContactUs;
          setContactCount(contactcount);
          const membershipcount = response.data.UserRegistration;
          setMembershipCount(membershipcount)
        })
      axios.get(getSpecificourt, {
        params: {
          date: currentdate
        }
      }).then((response) => {
        const newData = Array.isArray(response.data.data) ? response.data.data : [];
        setCourtid(newData || [])
        if (!newData.length || !newData[0].courts.length) return;

        const normalizeTimeLabel = (timeStr) => {
          const match = timeStr?.match(/(\d{1,2}):(\d{2})(AM|PM)/i);
          if (!match) return timeStr;
          const hour = String(Number(match[1])); // drop leading zero
          const minute = match[2];
          const period = match[3].toUpperCase();
          return `${hour}:${minute}${period}`;
        };

        const DISPLAY_TIMES = [
          "5:00AM", "6:00AM", "7:00AM", "8:00AM", "9:00AM", "10:00AM", "11:00AM",
          "12:00PM", "1:00PM", "2:00PM", "3:00PM", "4:00PM", "5:00PM", "6:00PM",
          "7:00PM", "8:00PM", "9:00PM", "10:00PM", "11:00PM"
        ];
        setTimes(DISPLAY_TIMES);

        const sortedCourts = [...newData[0].courts].sort((a, b) => parseInt(a.courtId) - parseInt(b.courtId));
        const slotMatrix = sortedCourts.map(court => {
          const slotsByTime = Object.values(court.slots || {}).reduce((acc, s) => {
            acc[normalizeTimeLabel(s.time)] = s;
            return acc;
          }, {});
          return DISPLAY_TIMES.map((timeLabel) => {
            if (court.courtStatus === "blocked") {
              return "not-alloted";
            }
            const slot = slotsByTime[timeLabel];
            if (!slot) return "not-alloted";
            return slot.status === "available"
              ? "not-booked"
              : slot.status === "booked"
                ? "booked"
              : slot.status === "bulk_booked" ?
              "bulk-booked"
                : "not-alloted";
          });
        });


        setSlotData(slotMatrix);
      });
    }
    catch(error) {
      console.error("Error fetching dashboard api:", error);
    };
  }, [currentdate]);


  return (
    <>
      <div className='dashboard-main-container'>
        <div className='slot-container' >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className='slot-head'>
              <PiCourtBasketball size={35} style={{ backgroundColor: 'white', borderRadius: '50%', padding: '5px' }} /> <span style={{ color: 'white' }}>Slot Booking</span>
            </div>
            <div style={{ display: 'flex', gap: '40px', alignItems: 'center' }}>
              <div className='slot-indicator' >
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <GoDotFill size={30} style={{ color: '#3A4450' }} /> Not Alloted
                </span>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <GoDotFill size={30} style={{ color: '#FF1515' }} /> Booked
                </span>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <GoDotFill size={30} style={{ color: '#3B82F6' }} /> Bulk Booked
                </span>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <GoDotFill size={30} style={{ color: '#39FF14' }} /> Not Booked
                </span>
              </div>
              <div >
                <GoArrowUpRight size={45} onClick={() => {
                  setDashActivePage('slotbooking')
                  setIsExporting(true)
                }} style={{ color: 'white', backgroundColor: '#FFFFFF1A', padding: '10px', borderRadius: '25px', cursor: 'pointer' }} />
              </div>
            </div>
          </div>

          <div className="slot-booking-container">
            {/**
             * Spread available width evenly so every slot column is visible without horizontal scrolling.
             * The first column is for court labels, followed by one column per time label.
             */}
            <div
              className="slot-grid"
              style={{
                gridTemplateColumns: `repeat(${times.length + 1}, ${100 / (times.length + 1)}%)`,
              }}
            >

              {courtNumber.map((court, rowIndex) => (
                <div key={`court-${rowIndex}`} className="row-wrapper">
                  <div className="cell header court">Court {court}</div>
                  {slotData[rowIndex].map((status, colIndex) => (
                    <div
                      key={`slot-${rowIndex}-${colIndex}`}
                      className={`cell slot ${status}`}
                    ></div>
                  ))}
                </div>
              ))}
              <div className="cell header empty"></div>

              {times.map((time, i) => (
                <div key={`time-${i}`} className="cell header time">{time}</div>
              ))}

            </div>
          </div>
        </div>
        <div className="member-contact-review">
          <div className="member" >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className='member-head'>
                <IoSparklesOutline size={35} style={{ backgroundColor: 'white', borderRadius: '50%', padding: '9px' }} /> <span style={{ color: 'white' }}>Membership</span>
              </div>
              <div>
                <GoArrowUpRight size={45} onClick={() => {
                  setDashActivePage('registration')
                  setIsExporting(true)
                }} style={{ color: 'white', backgroundColor: '#FFFFFF1A', padding: '10px', borderRadius: '25px', cursor: 'pointer' }} />
              </div>
            </div>
            <div>
              <h1 style={{ fontSize: '5rem', color: 'white' }}>{membershipCount}</h1>
            </div>
          </div>
          <div className="contact">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className='contact-head'>
                <BsBoxSeam size={35} style={{ backgroundColor: 'white', borderRadius: '50%', padding: '5px' }} /> <span style={{ color: 'white' }}>Contact Request</span>
              </div>
              <div>
                <GoArrowUpRight size={45} onClick={() => {
                  setDashActivePage('contactrequest')
                  setIsExporting(true)
                }} style={{ color: 'white', backgroundColor: '#FFFFFF1A', padding: '10px', borderRadius: '25px', cursor: 'pointer' }} />
              </div>
            </div>
            <div>
              <h1 style={{ fontSize: '5rem', color: 'white' }}>{contactCount}</h1>
            </div>
          </div>
          <div className="review">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className='review-head'>
                <GoStar size={35} style={{ backgroundColor: 'white', borderRadius: '50%', padding: '5px' }} /> <span style={{ color: 'white' }}>Feedback</span>
              </div>
              <div>
                <GoArrowUpRight size={45} onClick={() => {
                  setDashActivePage('feedback')
                  setIsExporting(true)
                }} style={{ color: 'white', backgroundColor: '#FFFFFF1A', padding: '10px', borderRadius: '25px', cursor: 'pointer' }} />
              </div>
            </div>
            <div>
              <h1 style={{ fontSize: '5rem', color: 'white' }}>{feedbackCount}</h1>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}

export default Dashboard
